// 临时把配置内容放这里  
const setting = {
  dev: {
    apiUrl: 'https://xms-ljhtest.internal.xbed.com.cn',
    debug: false,
    XCaStage: 'TEST',
    gateUrl: 'http://gateway-dev.api.xbed.com.cn',//GateWay分组
    noticeUrl: '/api/test/notice/xmsNews',
    biUrl: 'https://bi.api.xbed.com.cn',
    xmsUrl: 'https://xms.api.xbed.com.cn',//'http://3c6c6c263ad545efb17123954221481c-cn-shenzhen.alicloudapi.com',//自助入住分组
    orderUrl: 'https://order-dev.api.xbed.com.cn',// 'http://56ac14f9f0e145b181adfded70bac8fe-cn-shenzhen.alicloudapi.com',//阿里云OrderApi分组域名
    rubyUrl: 'https://rms.api.xbed.com.cn',//'http://8ad9ab3b832241abba14560f09950320-cn-shenzhen.alicloudapi.com',//房源中心分组
    roomUrl: 'https://room-dev.api.xbed.com.cn',//'http://91096f4a443c4b08a9c7c1775dad4ab8-cn-shenzhen.alicloudapi.com',//roomApi分组
    userUrl: 'https://user-dev.api.xbed.com.cn',//userApi分组
    roomSysUrl: 'https://roomsystem-dev.api.xbed.com.cn',//RoomSystem分组
    toolUrl: 'https://tool-dev.api.xbed.com.cn',//ToolApi分组
    doorLockUrl: 'https://doorlock-dev.api.xbed.com.cn',//DoorLockApi
    cleanUrl: 'https://cleaner-dev.api.xbed.com.cn',
    accountUrl: 'https://account-dev.api.xbed.com.cn',//account分组
    analysisUrl: 'https://analysis-dev.api.xbed.com.cn', //analysis
  },
  test: {
    apiUrl: 'https://xms-ljhtest.internal.xbed.com.cn',
    debug: false,
    XCaStage: 'TEST',
    gateUrl: 'https://gateway.api.xbed.com.cn',//GateWay分组
    noticeUrl: '/api/test/notice/xmsNews',
    biUrl: 'https://bi.api.xbed.com.cn',
    xmsUrl: 'https://xms.api.xbed.com.cn',//'http://3c6c6c263ad545efb17123954221481c-cn-shenzhen.alicloudapi.com',//自助入住分组
    orderUrl: 'https://order.api.xbed.com.cn',// 'http://56ac14f9f0e145b181adfded70bac8fe-cn-shenzhen.alicloudapi.com',//阿里云OrderApi分组域名
    rubyUrl: 'https://rms.api.xbed.com.cn',//'http://8ad9ab3b832241abba14560f09950320-cn-shenzhen.alicloudapi.com',//房源中心分组
    roomUrl: 'https://room.api.xbed.com.cn',//'http://91096f4a443c4b08a9c7c1775dad4ab8-cn-shenzhen.alicloudapi.com',//roomApi分组
    userUrl: 'https://user.api.xbed.com.cn',//userApi分组
    roomSysUrl: 'https://roomsystem.api.xbed.com.cn',//RoomSystem分组
    toolUrl: 'https://tool.api.xbed.com.cn',//ToolApi分组
    doorLockUrl: 'https://doorlock.api.xbed.com.cn',//DoorLockApi
    cleanUrl: 'https://cleaner.api.xbed.com.cn',
    accountUrl: 'https://account.api.xbed.com.cn',//account分组
    analysisUrl: 'https://analysis.api.xbed.com.cn', //analysis
  },
  staging: {
    apiUrl: 'https://pcb-staging.internal.xbed.com.cn:9994',
    debug: false,
    XCaStage: 'PRE',
    gateUrl: 'https://gateway.api.xbed.com.cn',//GateWay分组
    noticeUrl: '/api/pre/notice/xmsNews',
    biUrl: 'https://bi.api.xbed.com.cn',
    xmsUrl: 'https://xms.api.xbed.com.cn',//'http://3c6c6c263ad545efb17123954221481c-cn-shenzhen.alicloudapi.com',//自助入住分组
    orderUrl: 'https://order.api.xbed.com.cn',// 'http://56ac14f9f0e145b181adfded70bac8fe-cn-shenzhen.alicloudapi.com',//阿里云OrderApi分组域名
    rubyUrl: 'https://rms.api.xbed.com.cn',//'http://8ad9ab3b832241abba14560f09950320-cn-shenzhen.alicloudapi.com',//房源中心分组
    roomUrl: 'https://room.api.xbed.com.cn',//'http://91096f4a443c4b08a9c7c1775dad4ab8-cn-shenzhen.alicloudapi.com',//roomApi分组
    userUrl: 'https://user.api.xbed.com.cn',//userApi分组
    roomSysUrl: 'https://roomsystem.api.xbed.com.cn',//RoomSystem分组
    toolUrl: 'https://tool.api.xbed.com.cn',//ToolApi分组
    doorLockUrl: 'https://doorlock.api.xbed.com.cn',//DoorLockApi
    cleanUrl: 'https://cleaner.api.xbed.com.cn',
    accountUrl: 'https://account.api.xbed.com.cn',//account分组
    analysisUrl: 'https://analysis.api.xbed.com.cn', //analysis
  },
  production: {
    apiUrl: 'https://pcb.xbed.com.cn',
    debug: false,
    XCaStage: 'RELEASE',
    gateUrl: 'https://gateway.api.xbed.com.cn',//GateWay分组
    noticeUrl: '/api/notice/xmsNews',
    biUrl: 'https://bi.api.xbed.com.cn',
    xmsUrl: 'https://xms.api.xbed.com.cn',//'http://3c6c6c263ad545efb17123954221481c-cn-shenzhen.alicloudapi.com',//自助入住分组
    orderUrl: 'https://order.api.xbed.com.cn',// 'http://56ac14f9f0e145b181adfded70bac8fe-cn-shenzhen.alicloudapi.com',//阿里云OrderApi分组域名
    rubyUrl: 'https://rms.api.xbed.com.cn',//'http://8ad9ab3b832241abba14560f09950320-cn-shenzhen.alicloudapi.com',//房源中心分组
    roomUrl: 'https://room.api.xbed.com.cn',//'http://91096f4a443c4b08a9c7c1775dad4ab8-cn-shenzhen.alicloudapi.com',//roomApi分组
    userUrl: 'https://user.api.xbed.com.cn',//userApi分组
    roomSysUrl: 'https://roomsystem.api.xbed.com.cn',//RoomSystem分组
    toolUrl: 'https://tool.api.xbed.com.cn',//ToolApi分组
    doorLockUrl: 'https://doorlock.api.xbed.com.cn',//DoorLockApi
    cleanUrl: 'https://cleaner.api.xbed.com.cn',
    accountUrl: 'https://account.api.xbed.com.cn',//account分组
    analysisUrl: 'https://analysis.api.xbed.com.cn', //analysis
  }
}
const settingAli = {
  gateUrl: 'https://gateway.api.xbed.com.cn',//GateWay分组
  biUrl: 'https://bi.api.xbed.com.cn',
  xmsUrl: 'https://xms.api.xbed.com.cn',//'http://3c6c6c263ad545efb17123954221481c-cn-shenzhen.alicloudapi.com',//自助入住分组
  orderUrl: 'https://order.api.xbed.com.cn',// 'http://56ac14f9f0e145b181adfded70bac8fe-cn-shenzhen.alicloudapi.com',//阿里云OrderApi分组域名
  rubyUrl: 'https://rms.api.xbed.com.cn',//'http://8ad9ab3b832241abba14560f09950320-cn-shenzhen.alicloudapi.com',//房源中心分组
  roomUrl: 'https://room.api.xbed.com.cn',//'http://91096f4a443c4b08a9c7c1775dad4ab8-cn-shenzhen.alicloudapi.com',//roomApi分组
  userUrl: 'https://user.api.xbed.com.cn',//userApi分组
  roomSysUrl: 'https://roomsystem.api.xbed.com.cn',//RoomSystem分组
  toolUrl: 'https://tool.api.xbed.com.cn',//ToolApi分组
  doorLockUrl: 'https://doorlock.api.xbed.com.cn',//DoorLockApi
  cleanUrl: 'https://cleaner.api.xbed.com.cn',
  accountUrl: 'https://account.api.xbed.com.cn',//account分组
  analysisUrl: 'https://analysis.api.xbed.com.cn', //analysis
  intelligentcsUrl: 'https://intelligentcs.api.xbed.com.cn', //智能化
}


export default {
  apiUrl: setting[process.env.REACT_APP_ENVIRONMENT].apiUrl,
  debug: setting[process.env.REACT_APP_ENVIRONMENT].debug,
  XCaStage: setting[process.env.REACT_APP_ENVIRONMENT].XCaStage,
  noticeUrl: setting[process.env.REACT_APP_ENVIRONMENT].noticeUrl,
  biUrl: setting[process.env.REACT_APP_ENVIRONMENT].biUrl,
  xmsUrl: setting[process.env.REACT_APP_ENVIRONMENT].xmsUrl,
  orderUrl: setting[process.env.REACT_APP_ENVIRONMENT].orderUrl,
  rubyUrl: setting[process.env.REACT_APP_ENVIRONMENT].rubyUrl,
  roomUrl: setting[process.env.REACT_APP_ENVIRONMENT].roomUrl,
  userUrl: setting[process.env.REACT_APP_ENVIRONMENT].userUrl,//userApi分组
  roomSysUrl: setting[process.env.REACT_APP_ENVIRONMENT].roomSysUrl,//RoomSystem分组
  toolUrl: setting[process.env.REACT_APP_ENVIRONMENT].toolUrl,//ToolApi分组
  gateUrl: setting[process.env.REACT_APP_ENVIRONMENT].gateUrl,
  doorLockUrl: setting[process.env.REACT_APP_ENVIRONMENT].doorLockUrl,//DoorLockApi
  cleanUrl: setting[process.env.REACT_APP_ENVIRONMENT].cleanUrl,
  accountUrl: setting[process.env.REACT_APP_ENVIRONMENT].accountUrl,//account分组
  analysisUrl: setting[process.env.REACT_APP_ENVIRONMENT].analysisUrl, //analysis
  intelligentcsUrl: settingAli.intelligentcsUrl,//account分组
}


// WEBPACK FOOTER //
// ./src/api/config.js